import { render, staticRenderFns } from "./licenses.vue?vue&type=template&id=7b89d10a&scoped=true&"
import script from "./licenses.vue?vue&type=script&lang=js&"
export * from "./licenses.vue?vue&type=script&lang=js&"
import style0 from "./licenses.vue?vue&type=style&index=0&id=7b89d10a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b89d10a",
  null
  
)

export default component.exports